import { Component, ViewChild } from '@angular/core';
import { NgForm } from '@angular/forms';
import { NgbActiveModal } from '@ng-bootstrap/ng-bootstrap';
import { Address, InseeEtablissement, Supplier, SupplierAgency, Agency, DuplicateSupplierParameters } from '../../all-models';
import { SuppliersService } from '../../all-services';

@Component({
  selector: 'duplicate-supplier-modal',
  templateUrl: './duplicate-supplier-modal.component.html',
  styleUrls: ['./duplicate-supplier-modal.component.scss']
})
export class DuplicateSupplierModalComponent {

  private _supplierSrc?: Supplier;
  newSupplier: Supplier = new Supplier();
  inseeEtablissement?: InseeEtablissement = undefined;
  @ViewChild('frmDup') frmDup: NgForm;

  @ViewChild('frmMotif') frmMotif: NgForm;

  duplicateParameters: DuplicateSupplierParameters = new DuplicateSupplierParameters();


  get supplierSrc(): Supplier | undefined {
    return this._supplierSrc;
  }

  set supplierSrc(value: Supplier) {
    this._supplierSrc = value;
    this.newSupplier = new Supplier();
    this.address = new Address();
    this.duplicateParameters = new DuplicateSupplierParameters();
    this.inseeEtablissement = undefined;
    if (value) {
      let newSup: Supplier = Object.assign({}, value);
      newSup.Id = 0;
      newSup.Siret = undefined;
      newSup.TvaIntra = undefined;
      newSup.Rsa = undefined;
      newSup.Duns = undefined;
      // ON émule une agence pour le fournisseur afin que la recherche Insee binde l'étblissement trouvé dessus.
      let supAgency = new SupplierAgency();
      supAgency.IsSupplierAgency = 1;
      supAgency.Agency = new Agency();
      supAgency.Agency.Address = this.address;
      newSup.SupplierAgencies = [supAgency];
      this.newSupplier = newSup;
      this.duplicateParameters.SupplierId = value.Id;
    }
  }

  constructor(
    public activeModal: NgbActiveModal,
    public suppliersSvc: SuppliersService,
  ) { }
  findSiret(): void {
    this.inseeEtablissement = undefined;
    this.suppliersSvc.GetSupplierInseeEtablissement(this.newSupplier, true)
      .subscribe({
        next: res => {
          this.inseeEtablissement = res;
        },
        error: (reason: any) => {
          if (reason.status == 404) {
            this.frmDup.controls['siret'].setErrors({ 'SiretIntrouvable': 'Siret_inexistant' });
          } else {
            this.frmDup.controls['siret'].setErrors({ 'SiretIntrouvable': reason.error?.message || reason.message });
          }

        }
      });
  }

  address: Address = new Address();

  cancel(): void {
    this.activeModal.dismiss();
  }

  checkValidity(): void {
    [this.frmDup, this.frmMotif].forEach((f: NgForm) => {
      Object.keys(this.frmDup.form.controls).forEach(key => {
        f.form.controls[key].updateValueAndValidity({ onlySelf: false, emitEvent: true });
      });
      f.form.updateValueAndValidity();
    });
  }

  validate(): void {
    switch (this.newSupplier.FunctionalId) {
      case 'tvaintra':
        this.duplicateParameters.UniqueId = this.newSupplier.TvaIntra;
        break;
      case 'duns':
        this.duplicateParameters.UniqueId = this.newSupplier.Duns;
        break;
      case 'rsa':
        this.duplicateParameters.UniqueId = this.newSupplier.Rsa;
        break;
      default:
        this.duplicateParameters.UniqueId = this.newSupplier.Siret;
    }
    this.activeModal.close(this.duplicateParameters);
  }
}

